import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CappedPensionArrangementsFlexiConversionInstruction } from '../../Models/Domains/Drawdown/CappedPensionArrangementsFlexiConversionInstruction';

declare var IS_RUNNING_IN_APP_POOL;

export class CappedPensionArrangementsFlexiConversionInstructionsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(instructionId: number): Promise<CappedPensionArrangementsFlexiConversionInstruction, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Drawdown/CappedPensionArrangementsFlexiConversionInstructions/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId }

    return AjaxWrapper.get<CappedPensionArrangementsFlexiConversionInstruction, any>(url, data);
  }
  public post(instruction: CappedPensionArrangementsFlexiConversionInstruction): Promise<CappedPensionArrangementsFlexiConversionInstruction, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Drawdown/CappedPensionArrangementsFlexiConversionInstructions/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instruction: instruction }

    return AjaxWrapper.post<CappedPensionArrangementsFlexiConversionInstruction, any>(url, data);
  }
  public put(instructionId: number, instruction: CappedPensionArrangementsFlexiConversionInstruction): Promise<CappedPensionArrangementsFlexiConversionInstruction, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Drawdown/CappedPensionArrangementsFlexiConversionInstructions/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId, instruction: instruction }

    return AjaxWrapper.put<CappedPensionArrangementsFlexiConversionInstruction, any>(url, data);
  }
}

